module.exports = __webpack_public_path__ + "static/media/pick-helper.c87f0836.jpg";